import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
// import { GridRenderCellParams } from '@mui/x-data-grid';
import Avatar from '@mui/material/Avatar';
// import styles from './leagueTable.module.css';
import { Leaderboard } from '../../types/Leaderboard';
import { Competition } from '../../types/Competitions';
import { Player } from '../../types/Player';
import { Round } from '../../types/Round';

export interface CompetitionTableProps{
    competition?: Competition
}

const CompetitonTable: React.FC<CompetitionTableProps> = ({ competition })=>{
    
    // Cell Render Function
    const renderNameCell = (player: Player)=>{
        let initials = `${player?.firstname.charAt(0).toUpperCase()}${player?.lastname.charAt(0).toUpperCase()}`

        return(
            <TableCell >
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Avatar
                        sx={{
                            backgroundColor: "#040649",
                            marginRight: '15px',
                            width: '40px',
                            height: '40px',
                            fontSize: '15px'
                        }}
                        src={player?.image?.url}
                    >
                        {player?.image && initials}
                    </Avatar>
                    { player.firstname } { player.lastname }
                </div>
            </TableCell>
        )
    }

    // Helpers
    const generateDynamicHeaders = ()=>{
        const cells = [];
        const challenges = competition?.challenges || []

        for (let i = 0; i < challenges.length; i++) {
            const challenge = challenges[i];

            cells.push(
                <TableCell align="left" sx={{ backgroundColor: 'transparent', border: 'none' }}>
                    { challenge?.name }
                </TableCell>
            )
            
        }

        return cells
    }

    const calculateTotalScore = (rounds: Round[])=>{
        let score = 0;

        for (let i = 0; i < rounds.length; i++) {
            const round = rounds[i];
            score += round.score;
        }

        console.log(score)

        return score;
    }

    const generateRowData = ()=>{
        const dataRows: any[][] = [];

        const rounds = competition?.rounds || []
        const challenges = competition?.challenges || []
        const players = competition?.players || []

        for (let i = 0; i < players.length; i++) {
            const player = players[i];

            const roundsForPlayer = rounds.filter((r)=> r?.player?.id === player?.id)
            const totalPoints = calculateTotalScore(roundsForPlayer);

            const row = [];
            row.push(player)

            for (let j = 0; j < challenges.length; j++) {
                const challenge = challenges[j];
                const foundPlayer = roundsForPlayer.find((r)=> r.categoryId === challenge.id);
                let point = foundPlayer ? foundPlayer.score : "N/A";
                row.push(point)
            }

            row.push(totalPoints);

            dataRows.push(row);
            
        }

        dataRows.sort((a, b)=>{
            return b[b.length -1] - a[a.length -1]
        })

        return dataRows
    }

    return(
        <TableContainer sx={{ backgroundColor: '#f7f6f7'}}>
            <Table size='small' stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell align='left' sx={{ backgroundColor: 'transparent', border: 'none' }}>Rank</TableCell>
                        <TableCell align="left" sx={{ backgroundColor: 'transparent', border: 'none' }}>Contestant</TableCell>
                        { generateDynamicHeaders() }
                        <TableCell align="left" sx={{ backgroundColor: 'transparent', border: 'none' }}>Total Points</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow sx={{ padding: '5px 0' }}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    {
                        generateRowData().map((item, index)=>{

                            return(
                                <>
                                <TableRow key={index}
                                    sx={{
                                        backgroundColor: 'white',
                                    }}
                                    //className={index === 0 ? styles.rank1: ''}
                                >
                                    <TableCell
                                        sx={{ borderLeft: index === 0 ? '5px solid #FFD700': '5px solid #7300FA' }}
                                    >
                                        {index + 1}
                                    </TableCell>
                                    { renderNameCell(item[0]) }
                                    {
                                        item.slice(1, item.length - 1).map((points)=>(
                                            <TableCell>{points}</TableCell>
                                        ))
                                    }
                                    <TableCell>{item[item.length - 1]}</TableCell>
                                </TableRow>
                                <TableRow sx={{ padding: '5px 0' }}>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                </>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default CompetitonTable;